export default "__VITE_ASSET__BsMuDbYN__"